import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
  pdf,
} from '@react-pdf/renderer';
import Html from 'react-pdf-html';

interface Props {
  allData: any;
  showAllTrainingSummaryReports: boolean;
  setShowAllTrainingSummaryReports: any;
}

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 20,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0,
  },
  nextLine: {
    marginTop: -20,
    textAlign: 'center',
    fontSize: '10px',
  },
});

export const AllSummaryReports = (props: Props) => {
  const { allData, showAllTrainingSummaryReports, setShowAllTrainingSummaryReports } = props;
  console.log(allData);

  let pdfUrl = '';

  const getSummaryReportHTML = (data: any) => {
    return `<body>
                <style>
                  table td {
                  }

                  table th {
                    text-align: center;      
                  }

                  table {
                    margin: 3px 0px;
                    padding: 0px;
                    border: 1px solid black;
                    font-size: 10px;            
                  }          

                  table > tbody> tr > * {
                    padding: 3px;
                  }

                  .slNo {
                    border-left: 1px solid black;
                  }

                  th {
                    font-family: 'Times-Bold';          
                  }

                  .cardiovascular {
                    border-left: 1px solid black;
                    background-color: rgb(192, 192, 192);
                  }

                  .procedural {
                    border-left: 1px solid black;          
                  }

                  .colWidth {
                    min-width: 300px;
                  }
                </style>

                <div>
                  <table>
                    <thead>
                      <tr>
                        <th class='cardiovascular'>
                          <p>${data?.particulars}</p>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      ${data?.entry_setup_master_for_log?.map((section: any) => {
                        if (!section?.competency_group || section.competency_group.length === 0) {
                          return '';
                        }

                        const isProceduralSkill = section.particulars === "Procedural skill";
                        
                        return `
                          <tr>
                            <th class='procedural' colspan="4">
                              ${section?.particulars}
                            </th>
                          </tr>
                          <tr>
                            <th>Sl. No.</th>
                            <th style="min-width: 300px;">Skill</th>
                            ${isProceduralSkill ? `
                              <th>Level of competence</th>
                              <th>Minimum number required to be performed</th>
                            ` : `
                              <th>Minimum number to be performed</th>
                            `}
                          </tr>
                          ${section?.competency_group?.map((item: any, index: number) => {
                            // Calculate sum and divide by 2
                            const minValueSum = item?.log_entry_target?.reduce(
                              (sum: number, target: any) => sum + (Number(target?.min_value) || 0),
                              0
                            ) || 0;
                            const dividedValue = Math.round(minValueSum / 2);
                            
                            return `
                              <tr>
                                <td>${index + 1}</td>
                                <td style="min-width: 300px;">${item?.particulars}</td>
                                ${isProceduralSkill ? `
                                  <td>
                                    ${item?.log_entry_target?.map((target: any) => target?.compitency_level).filter(Boolean).join(', ') || 'N/A'}
                                  </td>
                                  <td>
                                    ${dividedValue}
                                  </td>
                                ` : `
                                  <td>
                                    ${dividedValue}
                                  </td>
                                `}
                              </tr>
                            `;
                          }).join('')}
                        `;
                      }).join('')}
                    </tbody>
                  </table>
                </div>
              </body>`;
  };

  const MyDocument = (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.row}>
          <Image
            src="/images/apple-icon-180x180.png"
            style={{
              width: '40px',
              marginTop: '20px',
              marginBottom: '0px',
              marginLeft: '10px',
            }}
          />
          <Text
            style={{
              textAlign: 'center',
              fontFamily: 'Times-Bold',
              fontSize: '14px',
              margin: '20px',
              marginBottom: '0px',
            }}
          >
            BANGLADESH COLLEGE OF PHYSICIANS AND SURGEONS (BCPS)
          </Text>
        </View>
        <Text style={styles.nextLine}>
          67, Shaheed Tajuddin Ahmed Sarani, Mohakhali, Dhaka-1212
        </Text>
        <Text
          style={{
            textAlign: 'center',
            fontFamily: 'Helvetica-Bold',
            fontSize: '14px',
            margin: '20px',
          }}
        >
          Summary of Procedural and Interpretative Skills
        </Text>
        {allData?.map((data: any, index: number) => (
          <View key={index} wrap={true}>
            <Html>{getSummaryReportHTML(data)}</Html>
          </View>
        ))}
      </Page>
    </Document>
  );

  if (showAllTrainingSummaryReports) {
    const pdfData = pdf(MyDocument).toBlob();
    pdfData.then((pdfData) => {
      const pdfContent = new Blob([pdfData], { type: 'application/pdf' });
      const url = URL.createObjectURL(pdfContent);
      pdfUrl = url;
      window.open(pdfUrl, '_blank');
      setShowAllTrainingSummaryReports(false);
    });
  }

  return null;
};